import PropTypes from 'prop-types/index.js';

export default PropTypes;
